import type { CSSProperties } from 'react';

import type { CompositionTypography } from './model';
import { AUTHORED_FONT_CSS } from '../typography/fonts';

export const COMPOSITION_FONT_CSS = AUTHORED_FONT_CSS;

/** The same 1.15em line box used by Composer page text, with half-leading on both sides. */
export function compositionTextBaseline(
  top: number,
  fontSize: number,
  ascent: number,
  descent: number,
): number {
  return top + ascent + (fontSize * 1.15 - ascent - descent) / 2;
}

export function compositionCanvasFont(
  typography: Pick<CompositionTypography, 'fontFamily' | 'fontSizePt' | 'fontStyle' | 'fontWeight'>,
  dpi: number,
): string {
  const sizePx = (typography.fontSizePt * dpi) / 72;
  const weight = typography.fontWeight === 'bold' ? 700 : 400;
  return `${typography.fontStyle} ${weight} ${sizePx}px "${COMPOSITION_FONT_CSS[typography.fontFamily]}"`;
}

export function compositionFontLoadRequest(
  typography: Pick<CompositionTypography, 'fontFamily' | 'fontStyle' | 'fontWeight'>,
): string {
  const weight = typography.fontWeight === 'bold' ? 700 : 400;
  return `${typography.fontStyle} ${weight} 48px "${COMPOSITION_FONT_CSS[typography.fontFamily]}"`;
}

export function compositionTypographyStyle(
  typography: CompositionTypography,
  pixelsPerMm: number,
): CSSProperties {
  return {
    color: typography.colour,
    fontFamily: `'${COMPOSITION_FONT_CSS[typography.fontFamily]}', sans-serif`,
    fontSize: `${typography.fontSizePt * 0.352778 * pixelsPerMm}px`,
    fontStyle: typography.fontStyle,
    fontWeight: typography.fontWeight === 'bold' ? 700 : 400,
    textAlign: typography.alignment === 'centre' ? 'center' : typography.alignment,
  };
}
